import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import style from './style'

import ScrollArea from '../../../../partials/ScrollArea'

export const ApplicationTable = props => {
  return (
    <ScrollArea
      style={{
        height: `300px`
      }}
    >
      <Col>
        <Row
          className={css(
            style.list.header,
            style[props.theme.name] ? style[props.theme.name].list.header : null
          )}
        />
        {props.applications.map((application, index) => (
          <CommunityRow
            theme={props.theme}
            key={`${index}_${application.id}`}
            onClick={props.onClick}
            application={application}
            community={
              props.communities.find(c => c.id === application.comId) || {}
            }
          />
        ))}
      </Col>
    </ScrollArea>
  )
}

export const CommunityRow = props => {
  const date = new Date(props.application.createdAt)
  const _date = {
    day: date.getUTCMonth(),
    month: date.toLocaleString('en-us', { month: 'short' }),
    year: date.getUTCFullYear(),
    hour: date.getUTCHours() % 12,
    minutes: date.getUTCMinutes(),
    pm: date.getUTCHours() >= 12
  }

  _date.day = `${('' + _date.day).length > 1 ? _date.day : '0' + _date.day}`
  _date.month = `${
    ('' + _date.month).length > 1 ? _date.month : '0' + _date.month
  }`

  return (
    <Row
      data-comid={props.application.comId}
      onClick={props.onClick}
      className={css(
        style.list.row,
        style[props.theme.name] ? style[props.theme.name].list.row : null,
        props.isActive
          ? style[props.theme.name]
            ? (style.list.activeRow, style[props.theme.name].list.activeRow)
            : style.list.activeRow
          : null
      )}
    >
      <Col>
        <Row>
          <Col xs='auto' />
          <Col>
            <Row>
              <Col>
                <span
                  className={css(
                    style.row.span,
                    style.row.nameSpan,
                    style.row.spanCenter
                  )}
                >
                  {props.community.name}
                </span>
              </Col>
            </Row>
            <Row>
              <Col>
                <span className={css(style.row.span, style.row.spanCenter)}>
                  (/{props.community.seo})
                </span>
              </Col>
            </Row>
          </Col>
          <Col
            xs='auto'
            className={`d-flex align-items-center justify-content-center`}
          >
            <span className={css(style.row.span, style.row.spanCenter)}>
              {(props.community.users || []).length} users
            </span>
          </Col>
          <Col className={`d-flex align-items-center justify-content-center`}>
            <span
              className={css(
                style.status.label,
                props.application.pending
                  ? style.status.pending
                  : props.application.approved
                    ? style.status.completed
                    : style.status.canceled
              )}
            >
              {props.application.pending
                ? `pending`
                : props.application.approved ? `approved` : `rejected`}
            </span>
          </Col>
          <Col xs='12' lg='auto'>
            <Row>
              <Col xs='12' className={`d-none d-lg-block`}>
                <span className={css(style.date.datetime, style.date.time)}>{`${
                  _date.hour
                }:${_date.minutes} ${_date.pm ? 'PM' : 'AM'}`}</span>
              </Col>
              <Col xs='12'>
                <span className={css(style.date.datetime, style.date.date)}>{`${
                  _date.month
                } ${_date.day} ${_date.year}`}</span>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default ApplicationTable



// WEBPACK FOOTER //
// ./src/components/Community/Main/partials/ApplicationTable/index.js